import { trackEvent } from '@patrianna/analytics'
import { useSocialButtonSpinner } from '@patrianna/shared-hooks'
import type { SocialAuthTypes } from '@patrianna/shared-patrianna-types/store/AuthModule'
import { getAuthFlowLoadingSelector } from '@patrianna/shared-store/auth'
import { Facebook } from '@patrianna-icons/material-icons'
import cx from 'classnames'

import Loader from 'components/Loader'
import { facebookAuth } from 'services/facebook/actions'
import Button from 'src/components/Button'
import { FACEBOOK_APP_ID } from 'src/config/apps'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'

import classes from './styles.module.scss'

type Props = {
  text: string
  authType: SocialAuthTypes
  disabled?: boolean
  skipTrackEvent?: boolean
}

function FacebookButton(props: Props) {
  const dispatch = useAppDispatch()
  const isLoading = useAppSelector(getAuthFlowLoadingSelector)
  const { isSendRequest, setIsSendRequest } = useSocialButtonSpinner(isLoading)

  const onClick = () => {
    setIsSendRequest(true)
    dispatch(facebookAuth(props.authType))

    if (!props.skipTrackEvent) {
      trackEvent('sign_up_started', {
        interaction_name: 'sign_up_started',
        sign_up_total_steps: 1,
        sign_up_current_step_number: 1,
        sign_up_interacted_element: 'facebook_button',
        sign_up_method: 'facebook',
      })

      if (props.authType === 'REGISTRATION') {
        trackEvent('register_page_facebook_button')
      }

      if (props.authType === 'LOGIN') {
        trackEvent('login_page_facebook_button')
      }
    }
  }

  if (FACEBOOK_APP_ID) {
    return (
      <Button
        onClick={onClick}
        disabled={props.disabled || isLoading}
        className={cx(classes.facebookBtn, isSendRequest && classes.loading)}
        type='button'
        data-test={props.text}
      >
        {isSendRequest && isLoading ? (
          <Loader size={28} />
        ) : (
          <>
            <span className={classes.buttonBox}>
              <Facebook className={classes.icon} />
              <span className={classes.text}>{props.text}</span>
            </span>
          </>
        )}
      </Button>
    )
  }

  return null
}

export default FacebookButton
